module.exports = __webpack_public_path__ + "img/about.406c34ab.png";